import config from 'config'
import { cookie } from 'cookie_js'

export default class AccessToken {
  static cookieName() {
    return config.auth_token_cookie_name
  }

  static get() {
    return cookie.get(this.cookieName()) || this.value
  }

  static set(val, rememberMe = false) {
    this.value = val

    // need manualy convert '/' to '%2F' so Rails server can read correctly
    cookie.utils.decode = value => String(value).replace(/[,;"+/\\=\s%]/g, character => encodeURIComponent(character))
    cookie.utils.encode = value => encodeURIComponent(value)

    cookie.set(this.cookieName(), this.value, {
      domain: config.auth_token_cookie_domain,
      expires: rememberMe ? 7 : 1,
      path: '/',
    })
  }
}
